export default __webpack_public_path__ + "static/media/img2.736881b0.jpg";